import { Link } from "react-router-dom";
import { Smartphone, Download, ArrowRight, Check } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useLang } from "@/context/LangContext";
import { INSTALL_UI as UI } from "@/data/installI18n";
import { useLatestApk } from "@/hooks/useLatestApk";
import { isPlayStoreApp } from "@/lib/apkVersion";
import { fill } from "@/lib/utils";

// Always-available APK re-download (Profile): never hidden once installed, only in the Google Play build.
export function ApkRedownloadCard() {
  const { tc } = useLang();
  const { latest, installedCode, updateAvailable } = useLatestApk();
  if (isPlayStoreApp()) return null;
  const status = installedCode === null ? null : updateAvailable ? "outdated" : "current";
  return (
    <Card className="rounded-3xl border-[hsl(var(--gold))]/40 bg-[hsl(var(--gold))]/5 shadow-sm p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="apk-redownload-card" data-version={latest.version}>
      <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[hsl(var(--gold))]/20 text-[hsl(var(--gold))]"><Smartphone className="h-6 w-6" /></span>
      <div className="min-w-0 flex-1">
        <p className="font-medium">{tc({ id: "Aplikasi Android (APK)", en: "Android app (APK)", ar: "تطبيق أندرويد (APK)" })} <span className="text-muted-foreground font-normal">v{latest.version}</span></p>
        <p className="text-xs text-muted-foreground mt-0.5">
          {status
            ? <span className="inline-flex items-center gap-1" data-testid="apk-redownload-status" data-status={status}><Check className="h-3.5 w-3.5 text-primary" />{fill(tc(status === "outdated" ? UI.apkOutdated : UI.apkUpToDate), { v: latest.version })}</span>
            : tc({ id: "Pasang di ponsel Android Anda atau bagikan ke rombongan — unduh ulang kapan saja.", en: "Install it on your Android phone or share it with your group — re-download any time.", ar: "ثبّته على هاتف أندرويد أو شاركه مع مجموعتك — أعد التنزيل في أي وقت." })}
        </p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <a href={latest.path} download data-testid="apk-redownload-btn">
          <Button className="h-10 rounded-full px-5"><Download className="me-2 h-4 w-4" />{installedCode === null ? tc({ id: "Unduh APK", en: "Download APK", ar: "تنزيل APK" }) : tc({ id: "Unduh ulang APK", en: "Re-download APK", ar: "إعادة تنزيل APK" })} <span className="ms-1 text-xs opacity-80">({latest.sizeMb} MB)</span></Button>
        </a>
        <Link to="/install" data-testid="apk-redownload-guide" className="inline-flex items-center gap-1.5 h-10 rounded-full border border-border/60 bg-background/70 px-4 text-sm font-medium hover:bg-background">
          {tc(UI.homeGuide)}<ArrowRight className="h-4 w-4 rtl:-scale-x-100" />
        </Link>
      </div>
    </Card>
  );
}
